import React from 'react'
import { Carousel, CarouselItem } from '@shared/components/carousel'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { smiList } from '@shared/components/sections/smi/data'

import styles from './styles.module.scss'

export const View = () => (
	<Section className={styles.wrapper}>
		<div className={styles.content}>
			<Carousel title={<h2>Почитайте о нас в СМИ</h2>}>
				{smiList.map(({ href, imgName, Svg, title }, i) => (
					<CarouselItem key={`${i}-${title}`}>
						<a className={styles.item} href={href} target='_blank' rel='noopener noreferrer nofollow'>
							<div className={styles.itemPhoto}>
								{Svg && <Svg />}
								{imgName && <Image lazy name={imgName} className={styles.photo} />}
							</div>
							<div className={styles.title}>{title}</div>
						</a>
					</CarouselItem>
				))}
			</Carousel>
		</div>
	</Section>
)
